import * as I18n from 'circe/I18n';
import { MESSAGES_PREFIXES } from 'domain/tap/constants';
import moment from 'moment';
export const getDATOrderStatus = (response) => {
  try {
    const total = response.summary.totalCount;
    const delivered = response.summary.stateCount.DELIVERED;
    const pending = response.summary.stateCount.CREATED;
    const cancelled = response.summary.stateCount.CANCELED;
    return {
      delivered,
      pending,
      total,
      cancelled,
    };
  } catch (e) {
    return {
      delivered: 0,
      pending: 0,
      total: 0,
      cancelled: 0,
    };
  }
};
export const getOrderStatus = (response) => {
  try {
    const total = response.summary.totalCount;
    const delivered = response.summary.stateCount.DELIVERED;
    const cancelled = response.summary.stateCount.CANCELED;
    const created = response.summary.stateCount.CREATED;
    return {
      delivered,
      cancelled,
      created,
      total,
    };
  } catch (e) {
    return {
      delivered: 0,
      cancelled: 0,
      created: 0,
      total: 0,
    };
  }
};

export const getShippersSuccessRate = (response) => {
  try {
    const { ordersPerVendor } = response;
    const structuredOutput = [];

    const output = {
      most: [],
      least: [],
    };

    Object.keys(ordersPerVendor).forEach((d) =>
      structuredOutput.push({
        name: d,
        Created: ordersPerVendor[d].stateCount.CREATED,
        Delivered: ordersPerVendor[d].stateCount.DELIVERED,
        Cancelled: ordersPerVendor[d].stateCount.CANCELED,
        total: ordersPerVendor[d].totalCount,
        successRate: `${(
          (ordersPerVendor[d].stateCount.DELIVERED / ordersPerVendor[d].totalCount) *
          100
        ).toFixed(2)} %`,
      }),
    );

    structuredOutput.sort((b, a) => a.successRate - b.successRate);

    output.most = structuredOutput.slice(0, 10);
    output.least = structuredOutput.reverse().slice(0, 10);

    return output;
  } catch (e) {
    return {
      most: [],
      least: [],
    };
  }
};

export const getRoutes = (routes) => {
  try {
    const trips = routes?.map((route) => {
      return route.dropoffs;
    });
    return trips || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getOrdersByCustomerData = (response) => {
  try {
    const { ordersPerCustomer } = response;

    // const [customers] = results[0].data[0].values;
    const structuredOutput = [];

    const output = {
      most: [],
      least: [],
    };

    Object.keys(ordersPerCustomer).forEach((d) => {
      structuredOutput.push({
        name: d,
        Created: ordersPerCustomer[d].stateCount.CREATED || 0,
        Delivered: ordersPerCustomer[d].stateCount.DELIVERED || 0,
        Cancelled: ordersPerCustomer[d].stateCount.CANCELED || 0,
        total: ordersPerCustomer[d].totalCount || 0,
      });
    });

    structuredOutput.sort((b, a) => a.total - b.total);

    output.most = structuredOutput.slice(0, 10);
    output.least = structuredOutput.reverse().slice(0, 10);

    return output;
  } catch (e) {
    return {
      most: [],
      least: [],
    };
  }
};

export const getOrdersByCategoryData = (response) => {
  try {
    const { ordersByCategory } = response;
    const structuredOutput = [];

    const output = {
      most: [],
      least: [],
    };

    Object.keys(ordersByCategory).forEach((d) => {
      structuredOutput.push({
        name: d,

        Total: ordersByCategory[d] || 0,
      });
    });

    structuredOutput.sort((b, a) => a.total - b.total);

    output.most = structuredOutput.slice(0, 10);
    output.least = structuredOutput.reverse().slice(0, 10);

    return output;
  } catch (e) {
    return {
      most: [],
      least: [],
    };
  }
};

export const getDatOrdersByCouriersData = (response) => {
  try {
    const { ordersPerCourier } = response;
    const structuredOutput = [];

    Object.keys(ordersPerCourier).forEach((d) => {
      structuredOutput.push({
        name: d,
        Delivered: ordersPerCourier[d].stateCount.DELIVERED,
        Pending: ordersPerCourier[d].stateCount.PENDING,
        total: ordersPerCourier[d].totalCount,
      });
    });

    structuredOutput.sort((b, a) => a.total - b.total);
    return structuredOutput;
  } catch (e) {
    return [];
  }
};

export const formatMapResponse = (response) => {
  try {
    const { results } = response;

    const output = [];

    results.forEach((result) => {
      output.push({
        driverId: result?.driverId || 'Unavailable',
        driverName: result?.driverName || 'Unavailable',
        driverPhone: result?.driverPhone || 'Unavailable',
        pickup: {
          description: result?.pickup?.location?.description || 'Unavailable',
          identifier: result?.pickup?.location?.identifier || 'Unavailable',
          address: result?.pickup?.location?.address || 'Unavailable',
          latitude: result?.pickup?.location?.coordinate?.latitude || 0,
          longitude: result?.pickup?.location?.coordinate?.longitude || 0,
        },
        driverLocation: {
          latitude:
            result?.driverLocation?.latitude || result?.pickup?.location?.coordinate?.latitude || 0,
          longitude:
            result?.driverLocation?.longitude ||
            result?.pickup?.location?.coordinate?.longitude ||
            0,
        },
      });
    });

    return output;
  } catch (e) {
    return [];
  }
};

export const getOrdersTypesDonut = (response) => {
  const structuredResponse = {
    DAT: 0,
    EXWORK: 0,
  };
  const output = [];

  try {
    structuredResponse.DAT = response.data.DAT;
    structuredResponse.EXWORK = response.data.EXWORK;

    output.push(
      { name: 'DAT', value: structuredResponse.DAT },
      { name: 'EXWORK', value: structuredResponse.EXWORK },
    );

    return output;
  } catch (e) {
    return output;
  }
};

export const getWaybillsPerDay = (response) => {
  try {
    const { orders } = response;
    const output = [];

    for (const order of orders) {
      output.push({
        name: moment(order.time).format('DD/MM'),
        date: moment(order.time).format('DD/MM/YYYY'),
        Delivered: order.statusSummary.stateCount.DELIVERED,
        Created: order.statusSummary.stateCount.CREATED,
        Cancelled: order.statusSummary.stateCount.CANCELED,
        total: order.statusSummary.totalCount,
      });
    }

    return output;
  } catch (e) {
    return [];
  }
};
